import { IMAGES } from "@/lib/constants";

const TILES = [
  {
    src: IMAGES.gallery2,
    span: "lg:col-span-7 lg:row-span-2 h-[420px] lg:h-full",
    label: "Wast Water · Lake District",
  },
  { src: IMAGES.gallery1, span: "lg:col-span-5 h-[260px]", label: "Borrowdale Valley" },
  { src: IMAGES.gallery3, span: "lg:col-span-3 h-[260px]", label: "Lakeland fellside" },
  { src: IMAGES.gallery4, span: "lg:col-span-2 h-[260px]", label: "Cumbrian fells" },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 md:py-32 bg-[#F9F8F6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 mb-14 gap-8 items-end">
          <div className="lg:col-span-7">
            <div className="overline mb-4">Field notes</div>
            <h2
              className="font-display text-4xl md:text-5xl lg:text-6xl font-light text-[#2A2726] tracking-tight leading-[1.05]"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              Days on the
              <br />
              <span className="italic font-extralight">English fells.</span>
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9">
            <p className="text-[#5C5654] leading-relaxed">
              A handful of recent days out — from glassy mornings on Wast Water
              to misty afternoons in Borrowdale and quiet limestone in the
              Forest of Bowland.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-5 lg:auto-rows-[260px]">
          {TILES.map((t, i) => (
            <figure
              key={i}
              className={`relative group overflow-hidden rounded-2xl ${t.span}`}
              data-testid={`gallery-tile-${i}`}
            >
              <img
                src={t.src}
                alt={t.label}
                className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <figcaption className="absolute bottom-4 left-4 text-white text-xs uppercase tracking-[0.22em] opacity-0 group-hover:opacity-100 transition-opacity">
                {t.label}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
